import { cloneDeep, omit } from 'lodash';

import { NormalizedTickets, QuantityChangeEvents } from '../../types';

/**
 * Updates the quantity of a ticket tier in a normalized tickets object.
 */
const updateTicketQuantity = (
  ticketsObj: NormalizedTickets,
  ticketTierId: string,
  event: QuantityChangeEvents
): NormalizedTickets => {
  const newTicketsObj = cloneDeep(ticketsObj);
  const ticket = newTicketsObj[ticketTierId];

  const newQuantity =
    event === QuantityChangeEvents.Increase
      ? ticket.quantity + 1
      : ticket.quantity - 1;

  if (newQuantity === 0) {
    return omit(newTicketsObj, ticketTierId);
  }

  newTicketsObj[ticketTierId].quantity = newQuantity;

  return newTicketsObj;
};

export default updateTicketQuantity;
